export class Discipline {
	public constructor(public id: string, public name: string) {}
}
